const VI_TRANSLATE = {
    multilang_example: "VD đa ngôn ngữ"
}

export default VI_TRANSLATE;
